module.exports = __webpack_public_path__ + "static/img/raas_train_5.92825e4.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/raas_train_5.svg
// module id = kpQx
// module chunks = 0